import { render, staticRenderFns } from "./InviteAccept.vue?vue&type=template&id=c0d58618&scoped=true"
import script from "./InviteAccept.vue?vue&type=script&lang=js"
export * from "./InviteAccept.vue?vue&type=script&lang=js"
import style0 from "./InviteAccept.vue?vue&type=style&index=0&id=c0d58618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d58618",
  null
  
)

export default component.exports